export default __webpack_public_path__ + "static/media/Emirhan.9eac4f7d.jpeg";